import AuthenticationService from "application/modules/authentication/AuthenticationService";

const getQueryBaseReports = () => {
  try {
    const groupMenu = AuthenticationService.getGroupMenus?.() || [];

    if (!Array.isArray(groupMenu)) return [];

    return groupMenu
      .map((item) => item?.callCenterReport || [])
      .filter(Array.isArray)
      .flat()
      .filter((menu) => menu && typeof menu === "object")
      .map((menu) => ({
        icon: menu?.icon?.trim?.() || "",
        key: menu?.key || "",
        name: menu?.menuName || "",
        url: menu?.url || "",
        productionReady: menu?.productionReady ?? false,
        description: menu?.description || "",
      }));
  } catch (err) {
    console.error("Error generating dynamic Query Base Reports:", err);
    return [];
  }
};

export { getQueryBaseReports };